angular.module('aprima-core-ui').directive('apFormGroup', [ function () {
    'use strict';

    return {
        require: 'apFormGroup',
        restrict: 'A',
        controller: 'ApFormGroupCtrl',
        link: {
            pre: function(scope, element, attrs, ctrl) {
                ctrl.init(attrs.apFormGroup);
            }
        }
    };
}]);


angular.module('aprima-core-ui').controller('ApFormGroupCtrl', [ '$scope', '$element', 'ApFormGroup',
    function ($scope, $element, ApFormGroup) {
        'use strict';

        var self = this;

        self.init = function init(name) {
            self.formGroup = new ApFormGroup(name, $scope, $element);
            return self.formGroup;
        };
    }
]);


angular.module('aprima-core-ui').factory('ApFormGroup', ['_', '$document',
    function (_, $document) {
        'use strict';

        function ApFormGroup(name, scope, $formGroup) {
            if(!scope) {
                this.addField = angular.noop;
                this.removeField = angular.noop;
                this.setFieldRequired = angular.noop;
                return;
            }

            var fields = {};
            var parentFormSubmitted = false;
            this.addField = addField;
            this.removeField = removeField;
            this.setFieldRequired = setFieldRequired;

            var $formGroupLabel = getLabel(name, $formGroup);

            scope.$on('ap:form:submitted', function() {
                parentFormSubmitted = true;
                updateValid();
            });

            function addField(id, ngModelCtrl, fieldElement) {
                var thisField = fields[id] = {
                    valid: true,
                    pristine: true,
                    required: false,
                    ngModel: ngModelCtrl,
                    element: fieldElement && (fieldElement.parent('.input-group').firstOrNull() || fieldElement)
                };

                // instead of adding watches on $pristine and $valid for each field,
                // hook into the places where they are being updated and then check to
                // see if each field and the formGroup is still valid after each change
                if(ngModelCtrl) {
                    ngModelCtrl._$setDirty = ngModelCtrl.$setDirty;
                    ngModelCtrl.$setDirty = function formGroupSetDirty() {
                        ngModelCtrl._$setDirty.apply(ngModelCtrl, arguments);
                        thisField.pristine = ngModelCtrl.$pristine;
                        updateValid();
                    };

                    ngModelCtrl._$setPristine = ngModelCtrl.$setPristine;
                    ngModelCtrl.$setPristine = function formGroupSetPristine() {
                        ngModelCtrl._$setPristine.apply(ngModelCtrl, arguments);
                        thisField.pristine = ngModelCtrl.$pristine;
                        updateValid();
                    };

                    ngModelCtrl._$setValidity = ngModelCtrl.$setValidity;
                    ngModelCtrl.$setValidity = function formGroupSetValidity() {
                        ngModelCtrl._$setValidity.apply(ngModelCtrl, arguments);
                        thisField.valid = ngModelCtrl.$valid;
                        updateValid();
                    };
                }
            }

            function removeField(id) {
                var field = fields[id];
                if(field && field.ngModel) {
                    // Remove the hooks that were added to ngModel when the field is removed
                    // from this formGroup
                    field.ngModel.$setDirty = field.ngModel._$setDirty;
                    field.ngModel.$setPristine = field.ngModel._$setPristine;
                    field.ngModel.$setValidity = field.ngModel._$setValidity;
                }
                delete fields[id];
            }

            function setFieldRequired(id, required) {
                if(fields[id]) {
                    fields[id].required = required;
                    updateRequired();
                }
            }

            function updateRequired() {
                var isRequired = _.some(fields, function(field) {
                    return field.required;
                });
                setFormGroupRequired(isRequired);
            }

            function updateValid () {
                var isValid = _.reduce(fields, function(result, field) {
                    var isFieldValid = field.valid || (field.pristine && !parentFormSubmitted);
                    setFieldValidity(field.element, isFieldValid);

                    return result && isFieldValid;
                }, true);
                setFormGroupValidity(isValid);
            }

            //these should be idempotent
            function setFormGroupValidity(isValid) {
                if($formGroup) {
                    $formGroup.toggleClass('ap-form-group-valid', isValid);
                    $formGroup.toggleClass('ap-form-group-invalid', !isValid);
                }
            }

            function setFieldValidity($field, isValid) {
                if($field) {
                    $field.toggleClass('ap-field-valid', isValid);
                    $field.toggleClass('ap-field-invalid', !isValid);
                }
            }

            function setFormGroupRequired(isRequired) {
                if($formGroupLabel) {
                    $formGroupLabel.toggleClass('ap-form-group-required', isRequired);
                }
            }
        }

        function getLabel (name, formGroup) {
            return name && $document.find('[ap-required-label-for="' + name + '"]').firstOrNull() ||
                    name && $document.find('label[for="' + name + '"]').firstOrNull() ||
                    formGroup && formGroup.find('label.control-label').firstOrNull();
        }

        return ApFormGroup;
    }
]);
